import { Directive, effect, inject, signal, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[coreAuthHasAllGroups]',
})
export class HasAllGroupsDirective {
  private _authService = inject(AuthService);
  private _templateRef = inject(TemplateRef<any>);
  private _viewContainer = inject(ViewContainerRef);
  private _show = signal(false);

  @Input({ alias: 'coreAuthHasAllGroups' })
  set groupCheck(groups: string[]) {
    if (!Array.isArray(groups)) {
      this._show.set(false);
      return;
    }
    const matches = groups.every((group) => this._authService.isInGroup(group));
    this._show.set(matches);
  }

  constructor() {
    effect(() => {
      this._viewContainer.clear();
      if (this._show()) {
        this._viewContainer.createEmbeddedView(this._templateRef);
      }
    });
  }
}
